/**
 * Thrown by {@link WorkspaceService.save} when a save is already in flight.
 *
 * Save is gated (not queued or cancelled) because the create path (first save
 * or `saveAs`) POSTs a new resource; two concurrent POSTs would create two
 * workspaces. Callers should either:
 *   - observe `saveState` and disable their trigger while saving, or
 *   - catch this error and surface it as a user-facing "already saving" hint.
 */
export class WorkspaceSaveInProgressError extends Error {
    constructor() {
        super('Workspace save is already in progress');
        this.name = 'WorkspaceSaveInProgressError';
    }
}
